import { faSpinner } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { PolymorphicType } from 'grommet/utils';
import { ComponentProps, ComponentType, JSX } from 'preact';

import styles from './style.scss';

type RoundButtonProps<T extends PolymorphicType = 'button'> = {
  as?: T;
  backgroundColor?: string;
  color?: string;
  width?: number;
  loading?: boolean;
  radius?: number;
} & (T extends keyof JSX.IntrinsicElements ? ComponentProps<T> : T extends ComponentType<infer P> ? P : never);

const RoundButton = <T extends PolymorphicType = 'button'>({
  as,
  backgroundColor,
  color,
  width,
  loading,
  radius,

  // override props
  children,
  className,
  style,
  ...rest
}: RoundButtonProps<T>) => {
  const Component = as || 'button';
  return (
    <Component
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...(Component === 'button' ? { type: 'button' } : undefined)}
      className={clsx(styles.roundButton, className)}
      style={{
        width: `${width}px`,
        height: `${width}px`,
        minWidth: `${width}px`,
        borderRadius: radius ? `${radius}px` : '50%',
        backgroundColor,
        color,
        ...style,
      }}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
    >
      <div className={styles.btnWrapper}>
        {!loading && children}
        {loading && (
          <div className={styles.loaderWrapper}>
            <FontAwesomeIcon className={styles.loader} icon={faSpinner} spin />
          </div>
        )}
      </div>
    </Component>
  );
};

export default RoundButton;
